import React, { useEffect, useState } from "react";
import { Loader2, BadgeCheck } from "lucide-react";
import Modal from "./Modal";

export default function WaiveBillingDialog({
  open,
  onClose,
  onConfirm,
  targetName,
  loading = false,
}) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={loading ? undefined : onClose}
      title="Waive billing"
      description={
        targetName
          ? `${targetName} will owe KES 0 going forward until un-waived.`
          : undefined
      }
    >
      <div className="space-y-4">
        <div className="flex items-start gap-3 rounded-lg border border-green-200 bg-green-50 p-3 text-sm text-green-800 dark:border-green-800 dark:bg-green-950 dark:text-green-300">
          <BadgeCheck className="mt-0.5 h-4 w-4 flex-none" />
          <span>
            The user's billing page will show a "Billing waived by Paysafi"
            badge and KES 0 total. You can un-waive this at any time.
          </span>
        </div>
        <div>
          <label className="label-base">Reason (optional)</label>
          <textarea
            className="input-base min-h-[88px]"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="e.g. Early adopter discount, strategic partnership…"
            disabled={loading}
          />
          <p className="mt-1 text-[11px] text-gray-500 dark:text-gray-400">
            Visible to the user on their billing page and recorded in the
            admin audit log.
          </p>
        </div>
        <div className="flex justify-end gap-2 pt-1">
          <button className="btn-secondary" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="btn-primary"
            onClick={() => onConfirm(reason.trim() || null)}
            disabled={loading}
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Waive billing
          </button>
        </div>
      </div>
    </Modal>
  );
}
